import { auth } from "services/firebase";
async function request(path, options = {}, authenticated = true) {
  const headers = { ...options.headers };
  if (authenticated) {
    if (!auth?.currentUser) throw new Error("Entre na sua conta para continuar.");
    headers.Authorization = `Bearer ${await auth.currentUser.getIdToken()}`;
  }
  const response = await fetch(path, { ...options, headers, cache: "no-store" });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.message || "Não foi possível consultar o contrato.");
  return body;
}
export const getCurrentContract = () => request("/api/contracts/current", {}, false);
export const getContractStatus = () => request("/api/contracts/status");
export const acceptContract = (contract) =>
  request("/api/contracts/accept", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      accepted: true,
      versionId: contract.versionId,
      sha256: contract.sha256,
    }),
  });
export const publishContract = (title, file) =>
  request(`/api/admin/contracts?${new URLSearchParams({ title })}`, {
    method: "POST",
    headers: { "Content-Type": "application/pdf" },
    body: file,
  });
